import { createApp } from 'vue'
import App from './App.vue'
import vant from 'vant';
import 'vant/lib/index.css';
import i18n from './i18n/index';
import router from "./router/index";
import { Dialog } from "vant"
// 引入pmicon
import "./assets/pmfont/iconfont.css";
// import { Tabbar, TabbarItem } from 'vant';

Dialog.setDefaultOptions({
    confirmButtonText: "確定",
    cancelButtonText: "キャンセル",
    confirmButtonColor: "#1989fa"
})
const app = createApp(App);
app.use(Dialog)
app.use(i18n)
app.use(vant)
app.use(router)
app.mount('#app')